// faqData.js - FAQ data structure (SIMPLIFIED VERSION)
// Add, edit or remove questions here without touching the component
// Structure: Simple flat array of FAQs

export const faqs = [
  {
    id: 'access',
    question: '¿Cómo accedo a una propiedad?',
    answer: 'Recibirás un enlace mágico (magic link) por correo electrónico que te permitirá acceder directamente a la propiedad. Este enlace es personal. Lo puedes pasar a cualquier persona que quieras. Los otros interesados en la propiedad disponen de otros enlaces únicos.',
    videoUrl: null
  },
  {
    id: 'navigate',
    question: '¿Cómo navego por la información de la propiedad?',
    answer: 'Una vez dentro, podrás ver todas las fotos, videos y características de la propiedad. Desplázate hacia abajo para ver la descripción completa.',
    videoUrl: null
  }
];

// NOTA: Para añadir más preguntas, simplemente agrega más objetos al array:
// {
//   id: 'unique-id',
//   question: 'Tu pregunta aquí',
//   answer: 'Tu respuesta aquí',
//   videoUrl: null  // o URL del video cuando esté disponible
// }